import $http from '@/config/request';

//搜索
export const searchKey = params => {
  return $http.post(`/resource/common/getUrlInfonew`, params)
  // return $http.post(`/resource/common/getUrlInfo`, params)
}

//搜索热词
export const hotKey = () => {
  return $http.post(`/resource/hotword/getHotWordInfo`)
}
